'use strict';

import { FilterType } from '@/store/constants';
import { objToArray, toRouteParams } from '@/utils/helpers';


export const currentRouteFilter = state => toRouteParams(state.filter);

//=================================================================================================================

export const filtered = (state, getters) => {
	const { type, value } = state.filter;
	switch(type) {
		case FilterType.all:      return getters.list;
		case FilterType.popular:  return getters.popular.data;
		case FilterType.risk:     return getters.byRisk(value).data;
		case FilterType.tone:     return getters.byTone(value).data;
		case FilterType.category: return getters.byCategories(value).data;
		case FilterType.search:   return getters.bySearchResults.data;

		default: throw new Error(`Unsupported filter type: ${type}`)
	}
}

//=================================================================================================================

export const all = (state, getters) => {
	return getters.find({ query: {} });
}

//=================================================================================================================

export const popular = (state, getters) => getters.find({
	query: {
		$limit: 10,
		$sort: { nbLikes: -1 },
	},
});

//=================================================================================================================

export const byRisk = (state, getters) => value => getters.find({
	query: { risk: value },
});

//=================================================================================================================

export const byTone = (state, getters) => value => getters.find({
	query: { tone: value },
});

//=================================================================================================================

export const byCategories = (state, getters) => value => getters.find({
	query: { category: value },
});

//=================================================================================================================

export const bySearchResults = (state, getters, rootState, rootGetters) => {
	const resultsByID = rootGetters['search/results'].map(({ id }) => id);
	return getters.find({
		query: { id: { $in: resultsByID } }
	});
}

//=================================================================================================================

export const categories = (state, getters) => {
	const categoriesByID = getters.list
		.reduce((map, { category }) => {
			const item = map[category] || (map[category] = { name: category, count: 0 });
			++item.count;
			return map;
		}, {});

	return objToArray(categoriesByID)
		.sort((a, b) => {
			if (a.name < b.name) { return -1 }
			if (a.name > b.name) { return +1 }
			return 0;
		});
}

//=================================================================================================================

export const categoryNames = (state, getters) => getters.categories.map(item => item.name).sort();

//=================================================================================================================

export const editDialogVisible = state => state.editDialog.visible;

//=================================================================================================================

export const editDialogCopy = state => state.editDialog.copy;

//=================================================================================================================

export const saveError = state => state.errorOnCreate || state.errorOnPatch;
